import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurface = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1.105263,0,0,1.105263,-1.326342,-1.254137)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,3L12,21",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1.105263,0,0,1.105263,-1.326342,-1.254137)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3,12L21,12",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1.105263,0,0,1.105263,-1.326342,-1.254137)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21,4.81L21,19.19C21,20.189 20.189,21 19.19,21L4.81,21C3.811,21 3,20.189 3,19.19L3,4.81C3,3.811 3.811,3 4.81,3L19.19,3C20.189,3 21,3.811 21,4.81Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		})
	] })
});
export default SvgSurface;
